import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { UtilsService } from './services/utils.service';

import { PlatformService } from './services/platform.service';
import { RouterOutlet } from '@angular/router';
import { MatProgressBar } from '@angular/material/progress-bar';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatProgressBar, RouterOutlet],
})
export class AppComponent {
  title = 'bisual-workers';
  public loading: boolean = false;

  private utils = inject(UtilsService);
  private platform = inject(PlatformService);

  constructor() {
    this.startListeningLoadingStatus();
    this.initDesktopPermissions();
  }

  private startListeningLoadingStatus() {
    this.utils.loadingObservable.subscribe(data => {
      this.loading = data;
    });
  }

  private initDesktopPermissions() {
    this.platform.requestAccessibilityPermissions();
  }
}
